// Workaround: Rehab/AGS stores sanitary sewer pipes with assetType "pipe" and
// systemType "Sanitary Sewer", but the asset schema registry uses "wwPipe".
// Call this whenever group set data enters the app so all consumers get the
// correct value without needing to handle the mapping individually.
export const normalizeGroupSetAssetType = (groupSet: {
  systemType: string;
  assetType: string;
}): string => {
  if (
    groupSet.systemType === 'Sanitary Sewer' &&
    groupSet.assetType === 'pipe'
  ) {
    return 'wwPipe';
  }
  return groupSet.assetType;
};
